/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CodexRouteImport } from './routes/codex'
import { Route as CreditsRouteImport } from './routes/credits'
import { Route as GameRouteImport } from './routes/game'
import { Route as HomeRouteImport } from './routes/home'
import { Route as IntroRouteImport } from './routes/intro'
import { Route as JourneyRouteImport } from './routes/journey'
import { Route as LanguageRouteImport } from './routes/language'
import { Route as OverworldRouteImport } from './routes/overworld'
import { Route as SettingsRouteImport } from './routes/settings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CodexRoute = CodexRouteImport.update({
  id: '/codex',
  path: '/codex',
  getParentRoute: () => rootRouteImport,
} as any)
const CreditsRoute = CreditsRouteImport.update({
  id: '/credits',
  path: '/credits',
  getParentRoute: () => rootRouteImport,
} as any)
const GameRoute = GameRouteImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const IntroRoute = IntroRouteImport.update({
  id: '/intro',
  path: '/intro',
  getParentRoute: () => rootRouteImport,
} as any)
const JourneyRoute = JourneyRouteImport.update({
  id: '/journey',
  path: '/journey',
  getParentRoute: () => rootRouteImport,
} as any)
const LanguageRoute = LanguageRouteImport.update({
  id: '/language',
  path: '/language',
  getParentRoute: () => rootRouteImport,
} as any)
const OverworldRoute = OverworldRouteImport.update({
  id: '/overworld',
  path: '/overworld',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/codex': typeof CodexRoute
  '/credits': typeof CreditsRoute
  '/game': typeof GameRoute
  '/home': typeof HomeRoute
  '/intro': typeof IntroRoute
  '/journey': typeof JourneyRoute
  '/language': typeof LanguageRoute
  '/overworld': typeof OverworldRoute
  '/settings': typeof SettingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/codex': typeof CodexRoute
  '/credits': typeof CreditsRoute
  '/game': typeof GameRoute
  '/home': typeof HomeRoute
  '/intro': typeof IntroRoute
  '/journey': typeof JourneyRoute
  '/language': typeof LanguageRoute
  '/overworld': typeof OverworldRoute
  '/settings': typeof SettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/codex': typeof CodexRoute
  '/credits': typeof CreditsRoute
  '/game': typeof GameRoute
  '/home': typeof HomeRoute
  '/intro': typeof IntroRoute
  '/journey': typeof JourneyRoute
  '/language': typeof LanguageRoute
  '/overworld': typeof OverworldRoute
  '/settings': typeof SettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/codex'
    | '/credits'
    | '/game'
    | '/home'
    | '/intro'
    | '/journey'
    | '/language'
    | '/overworld'
    | '/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/codex'
    | '/credits'
    | '/game'
    | '/home'
    | '/intro'
    | '/journey'
    | '/language'
    | '/overworld'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/codex'
    | '/credits'
    | '/game'
    | '/home'
    | '/intro'
    | '/journey'
    | '/language'
    | '/overworld'
    | '/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CodexRoute: typeof CodexRoute
  CreditsRoute: typeof CreditsRoute
  GameRoute: typeof GameRoute
  HomeRoute: typeof HomeRoute
  IntroRoute: typeof IntroRoute
  JourneyRoute: typeof JourneyRoute
  LanguageRoute: typeof LanguageRoute
  OverworldRoute: typeof OverworldRoute
  SettingsRoute: typeof SettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/codex': {
      id: '/codex'
      path: '/codex'
      fullPath: '/codex'
      preLoaderRoute: typeof CodexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/credits': {
      id: '/credits'
      path: '/credits'
      fullPath: '/credits'
      preLoaderRoute: typeof CreditsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game': {
      id: '/game'
      path: '/game'
      fullPath: '/game'
      preLoaderRoute: typeof GameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intro': {
      id: '/intro'
      path: '/intro'
      fullPath: '/intro'
      preLoaderRoute: typeof IntroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journey': {
      id: '/journey'
      path: '/journey'
      fullPath: '/journey'
      preLoaderRoute: typeof JourneyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/language': {
      id: '/language'
      path: '/language'
      fullPath: '/language'
      preLoaderRoute: typeof LanguageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overworld': {
      id: '/overworld'
      path: '/overworld'
      fullPath: '/overworld'
      preLoaderRoute: typeof OverworldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CodexRoute: CodexRoute,
  CreditsRoute: CreditsRoute,
  GameRoute: GameRoute,
  HomeRoute: HomeRoute,
  IntroRoute: IntroRoute,
  JourneyRoute: JourneyRoute,
  LanguageRoute: LanguageRoute,
  OverworldRoute: OverworldRoute,
  SettingsRoute: SettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
